import React, { forwardRef } from 'react';
import { styled, Tooltip } from '@mui/material';

import { useViewport } from 'contexts/viewport';
import Icon from 'shell/components/Icon';
import Text from 'shell/components/Text';

const TYPES = ['alert', 'info'];

const CustomTooltip = styled(({ className, $maxWidth, ...rest }) => (
    <Tooltip classes={{ popper: className }} {...rest} />
))(({ $maxWidth: maxWidth, theme }) => {
    return {
        '& .MuiTooltip-tooltip': {
            borderRadius: '8px',
            maxWidth,
            padding: theme.spacing(2),
            background: theme.palette.ensightful.neutral[800],
            color: theme.palette.ensightful.neutral[50],
            boxShadow: theme.palette.ensightful.shadows[1],
        },
        '& .MuiTooltip-arrow': {
            color: theme.palette.ensightful.neutral[800],
        },
    };
});

const AlertIcon = styled(Icon)(({ theme }) => {
    return {
        borderRadius: '50%',
        padding: '0.3125rem',
        fontSize: '1.5rem',
        background: theme.palette.ensightful.error[700],
        color: theme.palette.ensightful.shades[0],
    };
});

const InfoIcon = styled(Icon)(({ theme }) => {
    return {
        borderRadius: '50%',
        padding: '0.3125rem',
        fontSize: '1.5rem',
        background: theme.palette.ensightful.primary[500],
        color: theme.palette.ensightful.shades[0],
    };
});

export default forwardRef(({ content, maxWidth, type, ...rest }, ref) => {
    if (!TYPES.includes(type)) return <CustomTooltip ref={ref} $maxWidth={maxWidth} {...rest} />;

    const { device } = useViewport();

    const variant = {
        mobile: 'p2',
        tablet: 'p2',
        desktop: 'p2',
    }[device];

    return (
        <CustomTooltip
            ref={ref}
            title={
                typeof content === 'string' ? (
                    <Text color={'inherit'} variant={variant}>
                        {content}
                    </Text>
                ) : (
                    content
                )
            }
            $maxWidth={maxWidth}
            {...rest}
        >
            {type === 'info' ? <InfoIcon tabIndex={0} kind={'info'} /> : <AlertIcon tabIndex={0} kind={'error'} />}
        </CustomTooltip>
    );
});
